import {useState} from "react";
import {OwnershipTypeFormPopup} from "../form/OwnershipTypeFormPopup";
import {OwnershipTypeTable} from "../table/OwnershipTypeTable";

import {Button} from '@komune-io/g2-components'
import {useTranslation} from "react-i18next";
import {Row} from "@komune-io/g2-layout";
import {
  OwnershipType,
  OwnershipTypeCreateCommand,
  OwnershipTypeDeleteCommand,
  OwnershipTypeUpdateCommand
} from "../../model/OwnershipType";
import {
  useOwnershipTypeAllQuery,
  useOwnershipTypeCreateMutation, useOwnershipTypeDeleteMutation,
  useOwnershipTypeUpdateMutation
} from "../../api/OwnershipTypeApi";
import {PlatformSubSection} from "@tracabois/template";

interface OwnershipTypeSectionProps {
  title: string
}

export const OwnershipTypeSection = (props: OwnershipTypeSectionProps) => {
  const {title} = props
  const [selectedItem, setSelectedItem] = useState<Partial<OwnershipType> | undefined>(undefined)
  const {t} = useTranslation()
  const ownershipTypePageQuery = useOwnershipTypeAllQuery();
  const [createOwnershipType] = useOwnershipTypeCreateMutation()
  const [updateOwnershipType] = useOwnershipTypeUpdateMutation()
  const [deleteOwnershipType] = useOwnershipTypeDeleteMutation()

  const closePopup = () => {
    setSelectedItem(undefined)
  }

  const handleCreate = async (item: OwnershipTypeCreateCommand) => {
    await createOwnershipType(item)
    closePopup()
    ownershipTypePageQuery.refetch()
    return true
  }
  const handleUpdate = async (item: OwnershipTypeUpdateCommand) => {
    await updateOwnershipType(item)
    closePopup()
    ownershipTypePageQuery.refetch()
    return true
  }
  const handleDelete = async (item: OwnershipTypeDeleteCommand) => {
    await deleteOwnershipType(item)
    closePopup()
    ownershipTypePageQuery.refetch()
    return true
  }
  const clickHandler = (row: Row<OwnershipType>) => {
    setSelectedItem(row.original)
  }
  const actions = (<Button color="primary"
                           onClick={() => setSelectedItem({})}>{t("ownershipType.action.create", "Ajouter un type")}</Button>)
  return (
    <PlatformSubSection title={title}>
      <OwnershipTypeTable page={ownershipTypePageQuery.data}
                        onPageQueryChange={ownershipTypePageQuery.setPageQuery}
                        onRowClicked={clickHandler}
                        isLoading={ownershipTypePageQuery.isLoading}
                        actions={actions}
      />
      <OwnershipTypeFormPopup
        open={!!selectedItem} item={selectedItem || {}}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
        onCancel={closePopup}
      />
    </PlatformSubSection>
  )
}
